import React from 'react'
import Header from '../Header/Header'
import PortalNavHeader from '../PortalNavHeader/PortalNavHeader'
import PortalHelpLine, { hasPortalHelp } from '../PortalBrand/PortalHelpLine'
import { usePortalBrandContext } from '../PortalBrand/PortalBrandContext'
import { PORTAL_BRAND_STATUS } from '../PortalBrand/portalBrandStatus'

const PortalContainerPage = ({ children }) => {
  const portalBrand = usePortalBrandContext()

  return (
    <>
      <header className="sticky top-0 bg-paper z-10 shadow-sm">
        <Header />
        <PortalNavHeader />
      </header>
      <div className="overflow-y-auto">
        <div className="px-10 py-10 pb-20">
          {children}
        </div>
      </div>
      {portalBrand.status === PORTAL_BRAND_STATUS.LEGACY ? (
        <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-divider px-10 py-3 z-10 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-sm text-text-secondary">Need help?</span>
            <a
              href="mailto:support@mydebtlawyers.com"
              className="text-sm font-medium text-primary-main hover:underline"
            >
              support@mydebtlawyers.com
            </a>
            <span className="text-sm text-text-secondary">|</span>
            <a
              href="tel:+13472187093"
              className="text-sm font-medium text-primary-main hover:underline"
            >
              (347) 218-7093
            </a>
          </div>
        </div>
      ) : hasPortalHelp(portalBrand) && (
        <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-divider px-5 md:px-10 py-3 z-10 flex items-center justify-between">
          <PortalHelpLine portalBrand={portalBrand} />
        </div>
      )}
    </>
  )
}

export default PortalContainerPage
